// core
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'open-raptor-progress',
  templateUrl: './raptor-progress.component.html',
  styleUrls: ['./raptor-progress.component.scss']
})
export class RaptorProgressComponent implements OnInit {
  @Input() progress: any;
  @Input() pages: any;

  width: string = '1%';

  constructor() { }

  ngOnInit(): void {}

  ngOnChanges(changes: any) {
    if (
      changes.progress &&
      changes.progress.currentValue
    ) {
      if (this.pages) {
        this.width = Math.ceil((this.progress / this.pages) * 100) + '%';
      }
    }
  }
}
